// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"ConnectWallet_text-gradient__3FDyL","body":"ConnectWallet_body__1fJZi","top":"ConnectWallet_top__1RalK"};